import React from 'react';
import Typewriter from 'typewriter-effect';

const TypingHighlight = () => {
    return (
        <div className="highlight-gradient_2">
            <Typewriter
                options={{
                    strings: [
                        "Artificial Intelligence",
                        "AI Mastery",
                        "Deep Learning",
                        "Machine Learning"
                    ],
                    autoStart: true,
                    loop: true,
                    delay: 50,
                    deleteSpeed: 40,
                    wrapperClassName: 'inline-typing',
                    cursorClassName: 'cursor-inline'
                }}
            />
        </div>
    );
};

export default TypingHighlight;
